import { combineReducers } from 'redux';
import dashboard from '../reducer/DashboardReducer';
import global from '../reducer/GlobalReducer';
import login from '../reducer/LoginReducer';
import payment from '../reducer/PaymentReducer';
import form from '../reducer/UserReducer';


const appReducer = combineReducers({ 
    form,
    global,
    login,
    payment,
    dashboard
});



function removeState(state){
    let obj={}
    Object.entries(state).map(([itemKey, content,i]) => {   
        if((itemKey !=="global") && (itemKey !== "user") && (itemKey !== "institute")
         && (itemKey !== "branch")  && (itemKey !== "uiConfig") ){
            return delete state[itemKey]
        }else{
            return obj[itemKey]=content
        }
    })
    return obj
}

const reducer = (state, action) => {

    if (action.type ==="RESET_LOGIN_DATA") {
        state = undefined;
    }

    if (action.type ==="RESET_STATE") {
        let newState=removeState(state)
        return appReducer(newState, action);
    }

    return appReducer(state, action);
}

export default reducer;